<div [formGroup]="form" class="grid-12 login-page__input">
    <label class="grid-3 grid-mobile-4" [for]="id + '_value'"> {{ 'login.form.label.caisse' | i18n }}: </label>
    <div [id]="id" class="grid-6 login-page__input-autocomplete grid-mobile-4">
        <div class="angucomplete-holder">
            <input class="textfield" [id]="id + '_value'" formControlName="caisse" name="caisse" type="text" placeholder="" maxlength="524288" [matAutocomplete]="auto" (input)="onInputChange()" />
            <mat-autocomplete class="angucomplete-dropdown" autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSelectionChange($event)">
                <mat-option class="angucomplete-row angucomplete-selected-row" *ngFor="let option of filteredOptions | async" [value]="option" [disabled]="option.name === 'Pas de résultat.'">
                    {{ option.name }}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
</div>
